import axios, { AxiosError, type AxiosResponse, type InternalAxiosRequestConfig } from "axios";
import { toast } from "sonner";
import userStore from "@/stores/user-store";
import { isDuplicateRequest } from "./duplicate";
import errorStore from "@/stores/error-store";

export const BASE_URL = import.meta.env.VITE_APP_API_URL

const client = axios.create({
    baseURL: BASE_URL
})

const onRequest = (config: InternalAxiosRequestConfig<any>): any => {

    if (isDuplicateRequest(config)) {
        console.warn('🚫 Duplicate request blocked');
        return Promise.reject(new axios.Cancel('Duplicate request (within 3 seconds)'));
      }

    let token= userStore.state.token

    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
        config.headers['Accept'] = 'application/json'
        return config
    }

    return config
}

const onRequestError = (error: AxiosError) => {
    console.log("error", error.request,error.response)
    return Promise.reject(error)
}

const onResponse = (response: AxiosResponse) => {
    if (response.data?.balance) {
        userStore.setState((prev) => ({...prev, balance: response.data.balance }))
    }
    return response
}

interface ApiErrorData {
    error?: string;
}
const onResponseError = (error: AxiosError) => {
    console.log("error", error.request,error.response)

    if (error.code === "ERR_NETWORK") {
        document.querySelector('body')?.classList.remove('page-loading')
        errorStore.setState(state => ({ ...state, isNetworkError: true }));
        return Promise.reject(error);
    }

    if (error.response?.status === 502) {
        document.querySelector('body')?.classList.remove('page-loading')
        errorStore.setState(state => ({ ...state, isConstructionMode: true }));
        return Promise.reject(error);
    }

    // You may want to handle logout here by clearing the userStore if needed
    if (userStore.state.token && error.response?.status && window.location.pathname !== "/auth") {
        if (error.response.status === 403) {
            toast.error('شما به این بخش دسترسی ندارید.')
        }
    }
    // console.log(handleApiErrors(error))
    return Promise.reject(error)
}

client.interceptors.request.use(onRequest, onRequestError)
client.interceptors.response.use(onResponse, onResponseError)

export default client
